<template>
    <div class="form-group row" :class="{ 'has-danger' : form.errors.has(name) }">
        <label class="col-md-3 col-xl-2 col-sm-12 col-form-label" :for="name">{{ labelComputed }}</label>
        <div class="col-md-9 col-xl-10 col-sm-12">
            <vue-pikaday
                v-model="form[name]"
                :options="options"
                :required="required"
                :placeholder="placeholder_name"
                class="form-control"
                autocomplete="off"
                :disabled="disabled"
            />
            <span v-if="form.errors.has(name)" class="help-block form-control-feedback">
                {{ form.errors.get(name) }}
            </span>
        </div>
    </div>
</template>

<script>
    import { PikadayOptions } from ".";
    import FormGroup from "~/Form/elements"
    import LabelMixin from '~/mixins/label'

    export default {
        name: 'form-date-picker',
        mixins: [
            LabelMixin
        ],

        props: {
            form: {
                required: true,
            },
            placeholder: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                options: PikadayOptions,
            };
        },

        computed: {
            placeholder_name: function () {
                return this.placeholder === '' ? config.date_format_trans : this.uLang(this.placeholder)
            },
        },

        watch: {
            'form.trajectory_start_date': 'validateDates',
            'form.trajectory_end_date': 'validateDates'
        },
        methods: {
            validateDates() {
                if (this.form.trajectory_start_date && this.form.trajectory_end_date) {
                    const startDate = new Date(this.form.trajectory_start_date);
                    const endDate = new Date(this.form.trajectory_end_date);
                    if (endDate < startDate) {
                        this.form.trajectory_end_date = null;
                    }
                }
            }
        }
    }
</script>

<style lang="css">
    .pika-lendar {
        width: 600px !important;
    }
</style>
